import React from "react";
import { CaregiverAvailabilityFormView } from "./view";

export const CaregiverAvailabilityForm = props => (
  <CaregiverAvailabilityFormView {...props} />
);
